<div class="toolbar">
  @if (hasStepper) {
    <app-stepper
      [currentStep]="currentStep"
      [steps]="stepperSteps"
    ></app-stepper>
  }

  @for (item of items; track item) {
    <div>
      @if (item.itemType === itemType.BUTTON) {
        <app-button-component
          [value]="item.message"
          [buttonIcon]="item.icon"
          [hasPopOver]="item.hasPopOver"
          [disabled]="item.disable"
          [showPopoverOption]="item.showOption"
          [position]="item.position"
          [htmlData]="item.htmlData"
          [showdialog]="item.showdialog"
          [dropDownItems]="item.dropdownData"
          [popOverContent]="item.popOverContent"
          (clickButtonEvent)="item.action.call()"
          [openedComponent]="item.openedComponent"
        ></app-button-component>
      }
    </div>
  }
</div>
